import { ProjectsDto } from "src/data/models/projectsDtos/projectsDto.interface";
import { singleton } from "tsyringe";
import BaseService from "../Base/BaseService";

@singleton()
export class ProjectsService extends BaseService {
  constructor() {
    super();

    this.setMiddlware(this.errorCatcher, [
      "getProjects",
      "addProjects",
      "editProjects",
      "deleteProjects",
    ]);
    this.setMiddlware(this.handleToken, [
      "getProjects",
      "addProjects",
      "editProjects",
      "deleteProjects",
    ]);
  }

  async getProjects(): Promise<Array<ProjectsDto>> {
    const result = await this.repositoryWrapper.Projects.getProjects();
    return result.result;
  }

  async addProjects(data: ProjectsDto): Promise<ProjectsDto> {
    const result = await this.repositoryWrapper.Projects.addProjects(data);
    return result.result;
  }

  async editProjects(data: ProjectsDto): Promise<ProjectsDto> {
    const result = await this.repositoryWrapper.Projects.editProjects(data);
    return result.result;
  }
  async deleteProjects(projectId: number): Promise<number> {
    const result = await this.repositoryWrapper.Projects.deleteProjects(projectId);
    return result.result;
  }
}
